import React from "react";
import { InfoCircleIcon } from "../../../assets/Icons/InfoCircleIcon";
import { ORDER_TABS } from "../../../util/constants";

/**
 * ContributorsTab Component
 * Displays and manages the Contributors tab content
 * Handles DID Contributors with role-based validation and independence declaration requirements
 */
const ContributorsTab = ({
  currentTabFields,
  isEditing,
  fieldValues,
  errorFieldArray,
  fieldValidationErrors,
  renderFieldInput,
  hasValidationError,
  getValidationErrorMessage,
}) => {
  if (currentTabFields.length === 0) {
    return (
      <div className="orders-empty-state">
        <p>No fields available for Contributors.</p>
      </div>
    );
  }

  return (
    <>
      {/* Contributors Disclaimer - Independence Declaration Notice */}
      <div className="contributors-disclaimer">
        <InfoCircleIcon width="16" height="16" color="#dedee2" />
        <span>
          All GDS DID Contributors, regardless of role, are required to
          complete and sign off on the applicable independence declaration
          for this engagement in EY Canvas (or an equivalent system, where
          applicable).
        </span>
      </div>

      {/* Contributors Grid Layout */}
      <div className="details-grid contributors-grid" key={ORDER_TABS.CONTRIBUTORS}>
        {currentTabFields.map((field, index) => (
          <div
            key={`${ORDER_TABS.CONTRIBUTORS}-${field.field}-${index}`}
            className={`details-item ${
              errorFieldArray.includes(field.fieldStateKey) ? "has-error" : ""
            }`}
          >
            <div className="label">{field.labelToShowOnUI}</div>
            <div className="field-container">
              {renderFieldInput(field)}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default ContributorsTab;
